import * as models from './model';

export interface ICustomers {
    customers?: models.Customer[];
    allOnly?: boolean;
}
